import {
  Component,
  OnInit,
  NgZone,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { LoginService } from '../home/login.service';
import {
  FormBuilder,
  Validators,
  RadioControlValueAccessor,
} from '@angular/forms';
import { CheckoutService } from './checkout.service';
//import {CartComponent } from '../cart/cart.component';
import { IRep } from '../home/rep';
import { ICartItems } from '../onlineorder/cartitems';
import { OnlineOrderService } from '../onlineorder/onlineorder.service';
//import { CartComponent } from '../cart/cart.component';
import { ToastrService } from 'ngx-toastr';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ProductService } from '../products/products.service';
import { AppComponent } from '../app.component';
import { ViewChild, ElementRef } from '@angular/core';
import { OrderService } from '../onlineorder/order.service';
import { INexioSaveCardResponse } from './nexiosavecardresponse';
import { INexioToken } from './nexiotoken';
import { INexioTransactionResponse } from './nexiotransactionresponse';
import { ICardData } from './carddata';
import { JSEncrypt } from 'jsencrypt';
import { ShippingInfoComponent } from './shippinginfo.component';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from '../admin/admin.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ILatestOnlineOrder } from '../onlineorder/latestonlineorder';
@Component({
  standalone: false,
  templateUrl: './checkout.component.html',
})
export class CheckoutComponent implements OnInit, AfterViewInit, OnDestroy {
  public pageTitle: string = 'Checkout';
  private _prevSelected: any;
  public total!: number;
  public userId!: string;
  public orderId!: string;
  public cc: any;
  months!: string[];
  years!: string[];
  public ooInfo: ILatestOnlineOrder;
  nexioTokenObj!: INexioToken;
  $encrypt!: JSEncrypt; // JSEncrypt
  nexioSaveCardRes!: INexioSaveCardResponse;
  nexioCaptureRes!: INexioTransactionResponse;
  nexioBaseURL = 'https://api.nexiopay.com/pay/v3/saveCard?token=';
  nexioToken!: string;
  nexioURL!: string;
  ccGood!: boolean;
  achGood!: boolean;
  ccErrorMessage!: string;
  achErrorMessage!: string;
  popUpHtml: string = '<div>Please scroll below to checkout' + '</div>';
  @ViewChild(ShippingInfoComponent) child!: ShippingInfoComponent;
  @ViewChild('submitButton') submitButton!: ElementRef;
  private sub!: Subscription;
  cartItems!: ICartItems[];

  public caption: string;
  public transErrMsg: string;
  translatedText = '';

  public payments = [
    { value: 'CC', display: 'Credit Card' },
    { value: 'ACH', display: 'EFT' },
  ];

  public accountType = [
    { value: '2', display: 'Checking' },
    { value: '3', display: 'Savings' },
  ];

  public options = {
    position: ['bottom', 'right'],
    timeOut: 6000,
    lastOnBottom: true,
    preventDuplicates: false,
    preventLastDuplicates: false,
  };
  constructor(
    private _loginService: LoginService,
    public fb: FormBuilder,
    public checkout: CheckoutService,
    public orderService: OrderService,
    public toaster: ToastrService,
    public router: Router,
    private _route: ActivatedRoute,
    private _productService: ProductService,
    private app: AppComponent,
    private zone: NgZone,
    public translate: TranslateService,
    public admin: AdminService,
    public spinner: NgxSpinnerService,
    public onlineorder: OnlineOrderService
  ) {}

  private loadNuveiCheckoutScriptOnce(): Promise<void> {
    const id = 'nuvei-checkout-js';

    // already loaded?
    if (document.getElementById(id)) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.id = id;
      script.src =
        'https://cdn.safecharge.com/safecharge_resources/v1/checkout/checkout.js';

      // IMPORTANT: don't let it race the DOM
      script.async = false;
      script.defer = true;

      script.onload = () => resolve();
      script.onerror = () => reject();

      document.body.appendChild(script);
    });
  }

  ngAfterViewInit(): void {
    this.loadNuveiCheckoutScriptOnce().catch(() => {
      // swallow error so app never crashes if vendor CDN fails
    });

    //throw new Error('Method not implemented.');
  }
  getLocale(): any {
    var currentLocale = localStorage.getItem('locale');
    return currentLocale;
  }
  googleTranslateCall(textToTrans: string, targetLang: string): string {
    let model = {
      q: [textToTrans],
      target: targetLang,
    };
    this.admin.googleTranslate(model).subscribe((response: any) => {
      //console.log('Translate Call: ' + response.data.translations[0].translatedText);
      this.translatedText = response.data.translations[0].translatedText;
      return this.translatedText;
    });
    return '';
  }
  showError(errorMessage: string, subject: string, staticErrorMsg: boolean) {
    //use this for dynamic error messages
    if (staticErrorMsg === false) {
      let locale = this.getLocale();
      if (locale !== 'en') {
        //were gonna do it nested, couldn't do it as a standalone method.
        let model = {
          q: [errorMessage],
          target: locale,
        };

        this.admin.googleTranslate(model).subscribe(
          (response: any) => {
            let res = response.data.translations[0].translatedText as string;
            this.translatedText = response.data.translations[0]
              .translatedText as string;
            this.transErrMsg = this.translatedText;
            localStorage.setItem('translatedText', res);
          },
          (error) => console.log(error),
          () => {
            this.translate.get(subject).subscribe(
              (res: string) => {
                this.caption = res;
                console.log(res);
              },
              (error) => console.log(error),
              () => {
                this.spinner.hide();
                //once the caption is translated, fire off the toaster popup
                this.toaster.error(this.transErrMsg, this.caption, {
                  timeOut: 5000,
                });
                localStorage.removeItem('translatedText');
              },
            );
          },
        );

        //this.transErrMsg =  this.translatedText;
      } else {
        this.translate.get(subject).subscribe(
          (res: string) => {
            this.caption = res;
            console.log(res);
          },
          (error) => console.log(error),
          () => {
            this.transErrMsg = errorMessage;
            this.spinner.hide();
            //once the caption is translated, fire off the toaster popup
            this.toaster.error(this.transErrMsg, this.caption, {
              timeOut: 5000,
            });
            localStorage.removeItem('translatedText');
          },
        );
      }
    } else {
      // translate the error message - not dynamic
      this.translate.get(errorMessage).subscribe((res: string) => {
        this.transErrMsg = res;
        console.log(res);
      });

      // translate the caption
      this.translate.get(subject).subscribe((res: string) => {
        this.caption = res;
        console.log(res);
      });
      this.spinner.hide();
      //show the toaster popup
      this.toaster.error(this.transErrMsg, this.caption, {
        timeOut: 5000,
      });
    }
  }
  getCustId(): any {
    var currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}',
    );
    this.userId = currentUser && currentUser.userName;
    return this.userId;
  }

  clearCart() {
    if (this._loginService.loggedIn()) {
      this.cartItems = [];
      this.app.myProdCount = 0;
      //this.subTotal = 0;
      //this.tax = 0;
      this.total = 0;
      localStorage.removeItem('cartItems');
      this.orderService.clearCart(false);
      this.orderService.cart = [];
      this.orderService.tempCart = [];
      //this.orderService.updateShipMethodPlusTotals().subscribe();
      //this.calcTax();
      //this.calcTotal();

      localStorage.removeItem('prodCount');
    } else {
      this.cartItems = [];
      this.orderService.tempCart = [];
      localStorage.removeItem('cartItems');
      this.orderService.cart = [];
      this.app.myProdCount = 0;
      // this.subTotal = 0;
      //this.tax = 0;
      this.total = 0;
      //this.calcTax();
      //this.calcTotal();
      localStorage.removeItem('prodCount');
    }
  }

  // checkRouting() {
  //     this.checkout.checkRoutingNumber(this.checkoutForm.controls.custRouting.value).subscribe(data => {
  //         if (data == true) {
  //             this.achGood = true;
  //         }
  //         else {
  //             this.achGood = false;
  //             this.achErrorMessage = "That is not a valid routing number";
  //         }
  //     }, (error: any) => {
  //         this.achGood = false;
  //         this.achErrorMessage = "That is not a valid routing number";
  //     });

  //     return this.achGood;
  // }

  checkCC() {
    this.checkout
      .checkCCNumber(this.checkoutForm.controls.custCard.value)
      .subscribe(
        (data) => {
          if (data == true) {
            this.ccGood = true;
          } else {
            this.ccGood = false;
            this.ccErrorMessage = 'That is not a valid credit card number';
          }
        },
        (error) => {
          this.ccGood = false;
          this.ccErrorMessage = 'That is not a valid credit card number';
        },
      );

    return this.ccGood;
  }

  scrollDown(message: string): void {
    this.translate.get(message).subscribe((res: string) => {
      this.transErrMsg = res;
      console.log(res);
    });

    this.toaster.show('<div>' + this.transErrMsg + '</div>', 'info', {
      timeOut: 3000,
      enableHtml: true,
    });
  }

  // paymentFailure(message: string): void {

  //     this.toaster.error(message, "Error", {
  //         timeOut: 3000
  //     });
  // }
  public checkoutForm = this.fb.group({
    custFirst: ['', Validators.required],
    custLast: ['', Validators.required],
    custCard: [
      '',
      Validators.compose([Validators.required, Validators.minLength(16)]),
    ],
    custExpMonth: ['', Validators.required],
    cardType: ['', Validators.required],
    custExpYear: ['', Validators.required],
    custStreet: ['', Validators.required],
    custCvv: ['', Validators.required],
    custAmount: ['', Validators.required],
    custZip: [
      '',
      Validators.compose([Validators.required, Validators.minLength(5)]),
    ],
    custAccountNum: ['', Validators.required],
    custRouting: [
      '',
      Validators.compose([
        Validators.required,
        Validators.minLength(9),
        Validators.maxLength(9),
      ]),
    ],
    custAccountName: ['', Validators.required],
    custAccountType: ['', Validators.required],
    custAmt1: [''],
    paymentType: [''],
  });

  onButtonClick() {
    this.submitButton.nativeElement.disabled = true;
    //Do some other stuff, maybe call a service etc...
    //this.submitButton.nativeElement.disabled = false;
  }

  repId(): any {
    var currentId = localStorage.getItem('repId');
    return currentId;
  }
  // method to update address on order and recalc tax after all fields have been entered

  setRadioControl() {
    return this.checkoutForm.controls.paymentType.value;
  }

  encryptData(data: string | null) {
    this.$encrypt = new JSEncrypt();

    //Sandbox Key
    //let publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvWpIQFjQQCPpaIlJKpeg irp5kLkzLB1AxHmnLk73D3TJbAGqr1QmlsWDBtMPMRpdzzUM7ZwX3kzhIuATV4Pe 7RKp3nZlVmcrT0YCQXBrTwqZNh775z58GP2kZs+gVfNqBampJPzSB/hB62KkByhE Cn6grrRjiAVwJyZVEvs/2vrxaEpO+aE16emtX12RgI5JdzdOiNyZEQteU6zRBRJE ocPWVxExaOpVVVJ5+UnW0LcalzA+lRGRTrQJ5JguAPiAOzRPTK/lYFFpCAl/F8wt oAVG1c8zO2NcQ0Pko+fmeidRFxJ/did2btV+9Mkze3mBphwFmvnxa35LF+Cs/XJHDwIDAQAB';
    //Production Key
    var publicKey =
      'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA8gGPMwBRPuVyJReZGIkW H/+Bf5pnpDN1bSR2cLYLXVT8CaSnTw74qeboSnktgYCi1D9R3Bj2fYzTIwGGZb8K inLdxwbqZmHwrE9cFhCaHbG/E0PbqQGhXP2vbniZTT4M0i0Cbi7ES3Bw5zqNbIZZ nX041QEpxLvIyWPKZCX+fBogNMhWfCF779aclChjHkwZMsufThVWE9xklWGxXiyt x5aL4I5JPxq0I7cAkZGGs4aF/GxWwPaq7R3wPikJQ0YHnCMfcURzl2Hnw/inqyMy +JB6djTq2/BdzMAhWTh3cDWq9Xu+gEkb/QCd0n1yYIdKuDISlk/AfHdWe34IvzhVyQIDAQAB';

    //console.log(publicKey);
    try {
      this.$encrypt.setPublicKey(publicKey.toString());

      const res = this.$encrypt.encrypt(data);
      //console.log(res.toString());
      return res.toString();
    } catch (e) {
      return e;
    }
  }
  //Process Nexio Tokenized Payment
  // processCCNexio() {
  //   //Initialize card data to pass to the API
  //   this.cc = {};

  //   // assign the CC values
  //   this.cc.cardHolderName = this.checkoutForm.controls.custFirst.value;
  //   this.cc.cardHolderName += ' ';
  //   this.cc.cardHolderName += this.checkoutForm.controls.custLast.value;
  //   this.cc.expirationMonth = this.checkoutForm.controls.custExpMonth.value;
  //   this.cc.expirationYear = this.checkoutForm.controls.custExpYear.value
  //     .toString()
  //     .substring(2, 4);
  //   this.cc.securityCode = this.checkoutForm.controls.custCvv.value;
  //   this.cc.firstSix = this.checkoutForm.controls.custCard.value
  //     .toString()
  //     .substring(0, 6);
  //   this.cc.lastFour = this.checkoutForm.controls.custCard.value
  //     .toString()
  //     .substring(12, 16);

  //   //still need these two.
  //   this.cc.encryptedNumber = this.encryptData(
  //     this.checkoutForm.controls.custCard.value
  //   );
  //   this.cc.cardType = this.checkoutForm.controls.cardType.value;

  //   //console.log("Encrypted CC NUM: " + this.cc.encryptedNumber);
  //   //Save Card Nexio
  //   this.checkout.saveCardNexio(this.cc, this.nexioToken).subscribe(
  //     (res) => (this.nexioSaveCardRes = res),
  //     (error) => {
  //       this.checkout.getNexioToken().subscribe(
  //         (result) => (this.nexioTokenObj = result),
  //         (error) => console.log(error),
  //         () => {
  //           this.nexioToken = this.nexioTokenObj.token;
  //           localStorage.setItem('nexioToken', this.nexioToken);
  //         }
  //       );

  //       this.showError(error, 'Error', false);
  //       this.submitButton.nativeElement.disabled = false;
  //     },
  //     () => {
  //       if (this.nexioSaveCardRes.cvcResults.error) {
  //         this.showError(
  //           'shoppingCart.checkout.toastPopup.errors.paymentFailure',
  //           'Error',
  //           true
  //         );
  //         this.checkout.getNexioToken().subscribe(
  //           (result) => (this.nexioTokenObj = result),
  //           (error) => console.log(error),
  //           () => {
  //             this.nexioToken = this.nexioTokenObj.token;
  //             localStorage.setItem('nexioToken', this.nexioToken);
  //           }
  //         );
  //       }
  //       // else if(this.nexioSaveCardRes.kountResponse.status !== 'success'){
  //       //     this.paymentFailure("This card failed the fraud check, please check with your bank and then try again. ");
  //       //     this.checkout.getNexioToken().subscribe(result => this.nexioTokenObj = result, error => console.log(error),
  //       //         () => {
  //       //             this.nexioToken = this.nexioTokenObj.token;
  //       //             localStorage.setItem('nexioToken', this.nexioToken);
  //       //         });
  //       // }
  //       else {
  //         //Run Transaction Nexio
  //         this.checkout
  //           .runTransactionNexio(this.amountToPay(), this.nexioSaveCardRes)
  //           .subscribe(
  //             (res) => (this.nexioCaptureRes = res),
  //             (error) => {
  //               this.checkout.getNexioToken().subscribe(
  //                 (result) => (this.nexioTokenObj = result),
  //                 (error) => console.log(error),
  //                 () => {
  //                   this.nexioToken = this.nexioTokenObj.token;
  //                   localStorage.setItem('nexioToken', this.nexioToken);
  //                   this.submitButton.nativeElement.disabled = false;
  //                 }
  //               );

  //               // if (error.includes("CVV")) {
  //               //     this.paymentFailure("Your card information is invalid, please try again.");
  //               //     this.submitButton.nativeElement.disabled = false;

  //               // } else if (error.includes("AVS")) {
  //               //     this.paymentFailure("Address verification has failed, please try typing in the correct address accosicated with the card.");
  //               //     this.submitButton.nativeElement.disabled = false;

  //               // }
  //               // else if (error.includes("Gateway")) {
  //               //     this.paymentFailure("The card number is not correct, please try again.");
  //               //     this.submitButton.nativeElement.disabled = false;

  //               // }
  //               // else {
  //               this.showError(error, 'Error', false);
  //               //this.paymentFailure("Your card information is invalid, please try again.");
  //               this.submitButton.nativeElement.disabled = false;
  //               //}
  //             },
  //             () => {
  //               // Save to BDT Freedom
  //               this.checkout.BDTCCStore(this.nexioCaptureRes).subscribe(
  //                 (res1) => (this.orderId = res1),
  //                 (error) => this.showError(error, 'Error', false),
  //                 () => {
  //                   localStorage.setItem(
  //                     'completedOrderId',
  //                     JSON.stringify(this.orderId)
  //                   );

  //                   console.log(this.orderId);
  //                   this.orderId =
  //                     localStorage.getItem('completedOrderId') || '{}';

  //                   if (this.orderId != 'null') {
  //                     if (this.orderId != '0') {
  //                       setTimeout((router: Router) => {
  //                         this.router.navigateByUrl(
  //                           'completed/from/' + this.repId()
  //                         );
  //                       }, 2000);
  //                     }
  //                   }
  //                 }
  //               );
  //             }
  //           );
  //       }
  //     }
  //   );
  // }

  onSubmit(): void {
    var currentOrderInfo = JSON.parse(
      localStorage.getItem('orderInfo') || '{}',
    );
    //this.orderID = currentOrderInfo.BalanceDue;
    if (currentOrderInfo.balanceDueField !== undefined) {
      this.total = currentOrderInfo.balanceDueField;
    } else {
      this.total = currentOrderInfo.BalanceDue;
    }

    //update shipping info
    this.child.updateShippingAddress();
    this.submitButton.nativeElement.disabled = true;

    //this.processCCNexio();
    // this.checkout.processCCPayment(this.checkoutForm.controls.custFirst.value,
    //     this.checkoutForm.controls.custLast.value, this.checkoutForm.controls.custStreet.value,
    //     this.checkoutForm.controls.custZip.value, this.checkoutForm.controls.custCard.value,
    //     this.checkoutForm.controls.custExpMonth.value, this.checkoutForm.controls.custExpYear.value,
    //     this.checkoutForm.controls.custCvv.value, this.total).subscribe(thing => console.log(thing),
    // error => {
    //     this.paymentFailure(error);
    //     this.submitButton.nativeElement.disabled = false;
    // }, () =>
    // {
    //     this.orderId = localStorage.getItem('completedOrderId');
    //     console.log(this.orderId);
    //     if(this.orderId != "null"){
    //         if(this.orderId != "0"){
    //             setTimeout((router: Router) => {
    //                 this.router.navigateByUrl('completed/from/' + this.repId());
    //             }, 2000);
    //         }
    //         else{
    //             this.paymentFailure("Your payment failed to go through, please try again.");
    //             this.submitButton.nativeElement.disabled = false;
    //         }
    //     }
    //     else{
    //         this.paymentFailure("Your payment failed to go through, please try again.");
    //         this.submitButton.nativeElement.disabled = false;
    //     }

    // });
    // if (this.setRadioControl() === "CC") {
    //     this.submitButton.nativeElement.disabled = true;
    //     this.checkout.processCCPayment(this.checkoutForm.controls.custFirst.value,
    //         this.checkoutForm.controls.custLast.value, this.checkoutForm.controls.custStreet.value,
    //         this.checkoutForm.controls.custZip.value, this.checkoutForm.controls.custCard.value,
    //         this.checkoutForm.controls.custExpMonth.value, this.checkoutForm.controls.custExpYear.value,
    //         this.checkoutForm.controls.custCvv.value, this.total).subscribe(thing => console.log(thing),
    //         error => {
    //             this.paymentFailure(error);
    //             this.submitButton.nativeElement.disabled = false;
    //         }, () =>
    //         {
    //             this.orderId = localStorage.getItem('completedOrderId');
    //             console.log(this.orderId);
    //             if(this.orderId != "null"){
    //                 if(this.orderId != "0"){
    //                     setTimeout((router: Router) => {
    //                         this.router.navigateByUrl('completed/from/' + this.repId());
    //                     }, 2000);
    //                 }
    //                 else{
    //                     this.paymentFailure("Your payment failed to go through, please try again.");
    //                     this.submitButton.nativeElement.disabled = false;
    //                 }
    //             }
    //             else{
    //                 this.paymentFailure("Your payment failed to go through, please try again.");
    //                 this.submitButton.nativeElement.disabled = false;
    //             }

    //         });
    // }
    // else if (this.setRadioControl() === "ACH") {
    //     this.submitButton.nativeElement.disabled = true;
    //     this.checkout.processACHPayment(this.checkoutForm.controls.custAccountName.value,
    //         this.checkoutForm.controls.custAccountNum.value, this.checkoutForm.controls.custRouting.value,
    //         2, this.total).subscribe(thing => console.log(thing),
    //         error => {
    //             this.paymentFailure(error);
    //             this.submitButton.nativeElement.disabled = false;
    //         }, () =>  {
    //             this.orderId = localStorage.getItem('completedOrderId');
    //             console.log(this.orderId);
    //             if(this.orderId != "null"){
    //                 if(this.orderId != "0"){
    //                     setTimeout((router: Router) => {
    //                         this.router.navigateByUrl('completed/from/' + this.repId());
    //                     }, 2000);
    //                 }
    //                 else{
    //                     this.paymentFailure("Your payment failed to go through, please try again.");
    //                     this.submitButton.nativeElement.disabled = false;
    //                 }
    //             }
    //             else{
    //                 this.paymentFailure("Your payment failed to go through, please try again.");
    //                 this.submitButton.nativeElement.disabled = false;
    //             }
    //         });
    // }
  }
  cartTotal(): number {
    return 8.0;
  }
  amountToPay() {
    if (this._loginService.loggedIn()) {
      //this.orderService.updateShipMethodPlusTotals().subscribe();

      var currentOrderInfo = JSON.parse(
        localStorage.getItem('orderInfo') || '{}',
      );
      //this.orderID = currentOrderInfo.BalanceDue;
      if (currentOrderInfo.balanceDueField !== undefined) {
        this.total = currentOrderInfo.balanceDueField;
        return this.total;
      } else {
        this.total = currentOrderInfo.BalanceDue;
        return this.total;
      }
    } else {
      this.cartItems = this.orderService.getCart();
      this.total = 0;

      for (var i = 0; i < this.cartItems.length; i++) {
        this.total += this.cartItems[i].Quantity * 8.0;
      }
      return this.total;
    }
  }

  // balanceDueGreaterThanTenError(): void {

  //     this.toaster.error("It looks like you were working on another order along with this sample order. "
  //         + "For your convenience we have cleared your cart to prevent order duplication. You can now select your Free Sample Set", "Error", {
  //         timeOut: 3000
  //     });
  // }

  ngOnInit(): void {

    this.sub = this._route.params.subscribe((params) => {
      let id = +params['id'];
      this._productService.getRepInfo(id.toString()).subscribe((rep) => {
        //this.rep = rep;
        this.app.rep = rep;
      });
      localStorage.setItem('repId', id.toString());
    });

     

    // this.checkout.getNexioToken().subscribe(result => this.nexioTokenObj = result, error => console.log(error),
    //     () => {

    //         this.nexioToken = this.nexioTokenObj.token;
    //         //console.log(this.nexioTokenObj.token);
    //         localStorage.removeItem('nexioToken');
    //         localStorage.setItem('nexioToken', this.nexioToken);

    //         this.checkoutForm.controls.paymentType.setValue("CC");

    //         this.setRadioControl();
    //         this.months = [];
    //         this.years = [];
    //         var currentTime = new Date();
    //         var year = currentTime.getFullYear();

    //         for (var i = 1; i < 13; i++) {
    //             if (i < 10) {
    //                 this.months.push('0' + i);
    //             }
    //             else {
    //                 this.months.push(i.toString());
    //             }

    //         }

    //         for (var i = 0; i < 8; i++) {
    //             this.years.push(year.toString());
    //             year++;
    //         }

    //         this.checkoutForm.controls.custExpMonth.setValue('01');

    //         this.checkoutForm.controls.custExpYear.setValue(currentTime.getFullYear().toString());

    //         if (this.amountToPay() > 10) {
    //             this.clearCart();
    //             this.balanceDueGreaterThanTenError();
    //             this.zone.run(() => {
    //                 setTimeout((router: Router) => {
    //                     this.app.myRepID = this.repId();
    //                     this.router.navigateByUrl('shop/from/' + this.repId());
    //                 }, 10000);
    //             });

    //         }

    //     });

    //     if (this.amountToPay() > 10) {
    //         this.clearCart();
    //         this.balanceDueGreaterThanTenError();
    //         this.zone.run(() => {
    //             setTimeout((router: Router) => {
    //                 this.app.myRepID = this.repId();
    //                 this.router.navigateByUrl('shop/from/' + this.repId());
    //             }, 10000);
    //         });

    // }

    //console.log("EXP MONTH " + this.checkoutForm.controls.custExpMonth.value);
    //console.log("EXP YEAR " + this.checkoutForm.controls.custExpYear.value);
    // this._loginService.someLogin()
    // .subscribe()

    //check if logged in
    //refresh token?
  }

  // ngOnDestroy() {
  //   const scripts = document.querySelectorAll('script[src*="safecharge"]');
  //   scripts.forEach((s) => s.remove());
  // }

  ngOnDestroy(): void {
    document.getElementById('nuvei-checkout-js')?.remove();
  }
}
